import React, { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import Error404 from "modules/core/pages/Error404";

import { ideasPrivateRoutesConstants } from "./routesConstants";

import { componentLazyImport } from "modules/core/utils/helpers";

// Pages
const IdeasPage = lazy(() =>
  componentLazyImport(() => import("modules/ideas/pages/Ideas"))
);

const IdeasPrivateRoutes: React.FC = () => {
  return (
    <Switch>
      <Route path={ideasPrivateRoutesConstants.root.path}>
        <IdeasPage />
      </Route>

      <Route>
        <Error404 />
      </Route>
    </Switch>
  );
};

export default IdeasPrivateRoutes;
